import React, { useEffect } from 'react'
import useScrollToTop from '../../../hooks/useScrollToTop'
import { Grid, GridColumn, GridRow } from 'semantic-ui-react'
import Message from '../../common/Message'
import YesNoSelect from '../common/inputs/YesNoSelect'
import { useDispatch, useSelector } from 'react-redux'
import NameFields from '../common/fieldgroups/NameFields'
import PersonalFields from '../common/fieldgroups/PersonalFields'
import { setField, updateApplicantRelatedFields } from '../../../state/slice/form'
import {
  childrenFields,
  spouseFields
} from '../../../state/common/FORM_SEGMENTS'
import DynamicList from '../common/fieldgroups/DynamicList'
import DependentInputRow from './DependentInputRow'
import _ from 'lodash'

export default function SpouseAndDependents () {
  const dispatch = useDispatch()
  const {
    dependents: segment,
    dependents: {
      fields: { spouseApplying, childrenApplying }
    }
  } = useSelector(state => state.form.segments)

  useEffect(() => {
    if (spouseApplying.value) {
      dispatch(updateApplicantRelatedFields())
      dispatch(setField('segments.dependents.fields.spouse', spouseApplying.value === 'yes' ? spouseFields : {}, false, true))
    }
  }, [spouseApplying.value, dispatch])

  useEffect(() => {
    if (childrenApplying.value) {
      dispatch(updateApplicantRelatedFields())
      const isApplyingForChildren = childrenApplying.value === 'yes'
      if (isApplyingForChildren && _.isEmpty(segment.fields.children)) {
        dispatch(setField('segments.dependents.fields.children', [childrenFields], false, true))
      }
      if (!isApplyingForChildren) {
        dispatch(setField('segments.dependents.fields.children', [], false, true))
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [childrenApplying.value, dispatch])

  return useScrollToTop(<Grid divided='vertically' className='u-mB2'>
    <GridRow>
      <GridColumn width={16}>
        <Message content='Only provide information for any eligible dependents (spouse and/or children).
        For example, if you are only applying for insurance for yourself and your spouse,
        you would not provide information for any children.' />
      </GridColumn>
      <GridColumn width={13} verticalAlign='middle'>
        <h6>Indicate Whether Your Eligible Dependent Spouse is Applying for Coverage:</h6>
      </GridColumn>
      <GridColumn width={3} verticalAlign='middle'>
        <YesNoSelect
          id='spouseApplying'
          path='segments.dependents.fields.spouseApplying'
          label=''
        />
      </GridColumn>
      {(spouseApplying.value === 'yes' && !_.isEmpty(segment.fields.spouse)) && <>
        <NameFields rootPath='segments.dependents.fields.spouse' />
        <PersonalFields rootPath='segments.dependents.fields.spouse.personal' />
      </>}
    </GridRow>
    <GridRow>
      <GridColumn width={13} verticalAlign='middle'>
        <h6>Indicate Whether Any Eligible Dependent Children are Applying for Coverage:</h6>
      </GridColumn>
      <GridColumn width={3} verticalAlign='middle'>
        <YesNoSelect
          id='childrenApplying'
          path='segments.dependents.fields.childrenApplying'
          label=''
        />
      </GridColumn>
      {childrenApplying.value === 'yes' && <DynamicList
        path={'segments.dependents.fields.children'}
        defaultObject={childrenFields}
        RowElement={DependentInputRow}
        maxLength={4}
      />}
    </GridRow>
  </Grid>)
}